module.exports = __webpack_public_path__ + "e3e2d04d36f5be65f2fb4fa2e13c4fe7.png";